import { Action, createReducer, on } from "@ngrx/store";

import {
	AgreementsAcceptedSuccess,
	ByPassAgreements,
	SessionRefreshed,
	UserStatusLoaded,
	UserStatusRequested,
	UserStatusRequestFailed
} from "../actions/user.actions";
import { UserStatusState } from "../models/user-status-state";

const initialState: UserStatusState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(UserStatusRequested, (): UserStatusState => ({ ...initialState, requestInFlight: true })),
	on(UserStatusLoaded, (state, action) => {
		return {
			...state,
			...action.userStatus,
			loading: false,
			requestInFlight: false
		};
	}),
	on(UserStatusRequestFailed, (state: UserStatusState, action) => ({
		...state,
		error: action.error,
		loading: false,
		requestInFlight: false
	})),
	on(AgreementsAcceptedSuccess, (state: UserStatusState) => ({
		...state,
		agreementsPendingAcceptance: {}
	})),
	on(ByPassAgreements, (state: UserStatusState) => {
		const currentUserStatus = JSON.parse(sessionStorage.getItem("userStatus") || "{}");
		const updatedUserStatus = {
			...currentUserStatus,
			agreementsPendingAcceptance: []
		};
		sessionStorage.setItem("userStatus", JSON.stringify(updatedUserStatus));
		return {
			...state,
			agreementsPendingAcceptance: {}
		};
	}),
	// Fires on every navigation with whatever snapshot sessionStorage holds. While a real
	// /get-status is in flight that snapshot may be stale (a previous session in this tab,
	// or a since-changed account), and marking it `loading: false` would let the portal-home
	// gate render a verdict from it — the brief flash of the wrong account panel at login.
	on(SessionRefreshed, (state, action) =>
		state.requestInFlight
			? state
			: {
					...state,
					...action.userStatus,
					loading: false
				}
	)
);

export function userStatusReducer(
	state: UserStatusState | undefined,
	action: Action
): UserStatusState {
	return reducer(state, action);
}
